import React from "react";
import { SnapshotMetricCard } from "../dashboard/SnapshotMetricCard";
import { AccountsReceivableDashboard } from "../accounts-receivable/AccountsReceivableDashboard";
import {
  buildInvoiceHubFinancialMetrics,
  buildInvoiceHubRecentMetrics,
  buildInvoiceHubStatusMetrics,
} from "../../helpers/invoiceHubDashboard";

/**
 * Desktop Invoice Hub dashboard — rearranges existing snapshot cards.
 * Hidden on mobile via CSS (`.invoice-hub__dashboard`).
 */
export function InvoiceHubDashboard({
  invoices = [],
  loading = false,
  onSelectStatus,
  onOpenInvoice,
  arMetrics = null,
  arLoading = false,
  showAccountsReceivable = false,
}) {
  if (loading) {
    return (
      <div className="invoice-hub__dashboard" aria-hidden="true">
        <p style={{ opacity: 0.7 }}>Loading dashboard…</p>
      </div>
    );
  }

  const statusMetrics = buildInvoiceHubStatusMetrics(invoices, {
    onSelectStatus,
  });
  const financialMetrics = buildInvoiceHubFinancialMetrics(invoices);
  const recentMetrics = buildInvoiceHubRecentMetrics(invoices, {
    onOpen: onOpenInvoice,
    limit: 5,
  });

  return (
    <div className="invoice-hub__dashboard">
      <div className="invoice-hub__dashboard-grid">
        <SnapshotMetricCard
          title="Invoice Status"
          subtitle="Tap a status to filter the list"
          metrics={statusMetrics}
        />
        <SnapshotMetricCard
          title="Financial Summary"
          subtitle="From invoices in this hub"
          metrics={financialMetrics}
        />
        <SnapshotMetricCard
          title="Recent Invoices"
          subtitle="Most recently updated"
          metrics={recentMetrics}
          emptyMessage="No invoices yet."
        />
        {showAccountsReceivable ? (
          <div className="invoice-hub__ar-slot">
            <AccountsReceivableDashboard
              metrics={arMetrics}
              loading={arLoading}
              className="invoice-hub__ar-dashboard"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
